/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Reminder_DaysInputs */

const en_us2_profile_editors_reminder_days = /** @type {(inputs: Profile_Editors_Reminder_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On which days?`)
};

const pt_br2_profile_editors_reminder_days = /** @type {(inputs: Profile_Editors_Reminder_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em quais dias?`)
};

const es_419_profile_editors_reminder_days = /** @type {(inputs: Profile_Editors_Reminder_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué días?`)
};

const pt_pt2_profile_editors_reminder_days = /** @type {(inputs: Profile_Editors_Reminder_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Em que dias?`)
};

const fr_fr2_profile_editors_reminder_days = /** @type {(inputs: Profile_Editors_Reminder_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quels jours ?`)
};

const de_de2_profile_editors_reminder_days = /** @type {(inputs: Profile_Editors_Reminder_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An welchen Tagen?`)
};

const it_it2_profile_editors_reminder_days = /** @type {(inputs: Profile_Editors_Reminder_DaysInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In quali giorni?`)
};

/**
* | output |
* | --- |
* | "On which days?" |
*
* @param {Profile_Editors_Reminder_DaysInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_reminder_days = /** @type {((inputs?: Profile_Editors_Reminder_DaysInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Reminder_DaysInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_reminder_days(inputs)
	if (locale === "es-419") return es_419_profile_editors_reminder_days(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_reminder_days(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_reminder_days(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_reminder_days(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_reminder_days(inputs)
	return en_us2_profile_editors_reminder_days(inputs)
});
export { profile_editors_reminder_days as "profile-editors.reminder_days" }